import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const API_URL = import.meta.env.VITE_API_URL;


const ChatInput = ({ onSendMessage, isLoading, onResetChat }) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (message?.trim() && !isLoading) {
      console.log("Sending message:", message);  
      onSendMessage(message?.trim());
      setMessage('');
    } else {
      console.log("Message is empty or loading...");  
    }
  };

  const handleKeyPress = (e) => {
    if (e?.key === 'Enter' && !e?.shiftKey) {
      e?.preventDefault();
      handleSubmit(e);
    }
  };

  const handleResetChat = async () => {
    console.log("Sending request to reset chat...");

    try {
      const response = await fetch(`${API_URL}/reset_chat`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });

      const data = await response.json(); // parse once

      if (data.redirect) {
        alert("Please login first");
        window.location.href = data.redirect;
        return;
      }

      if (!response.ok) {
        console.error("Failed to reset chat:", data.error);
        return;
      }

      console.log("Chat reset successfully");
      if (typeof onResetChat === "function") {
        onResetChat();
      }

    } catch (error) {
      console.error("Error while resetting chat:", error);
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-surface border-t border-border shadow-soft">
      <div className="max-w-4xl mx-auto p-4">
        <form onSubmit={handleSubmit} className="flex items-end space-x-3">
          <div className="flex-1">
            <Input
              type="text"
              placeholder="هر سوالی درباره امور مالی داری از من بپرس..."
              value={message}
              onChange={(e) => setMessage(e?.target?.value)}
              onKeyPress={handleKeyPress}
              disabled={isLoading}
              className="resize-none"
            />
          </div>
          <Button
            type="submit"
            variant="default"
            size="default"
            disabled={!message?.trim() || isLoading}
            loading={isLoading}
            iconName="Send"
            iconPosition="right"
            iconSize={16}
            className="px-6"
          >
            ارسال
          </Button>
        </form>
        
        <div className="flex flex-wrap gap-2 mt-3">
          <Button
            variant="outline"
            size="sm"
            onClick={handleResetChat}
            disabled={isLoading}
            className="text-xs"
          >
            ریست چت
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ChatInput;
